import { CfsMenuItemData } from "clearline-api";

export enum CarouselErrorModalErrorTypeEnum {
  invalidToken = "invalidToken",
  invalidLocationId = "invalidLocationId",
  invalidAccountTemplateId = "invalidAccountTemplateId",
  invalidCashRegisterId = "invalidCashRegisterId",
  unknownError = "unknownError"
}

export enum CarouselUserActionType {
  goBack = "goBack",
  menuFeature = "menuFeature",
  pincode = "pincode",
  templateAction = "templateAction",
  gestureDestination = "gestureDestination",
  menu = "menu"
}

export interface CarouselUserAction {
  actionType: CarouselUserActionType;
  afterCloseActionType?: CarouselUserActionType;
  redirectUrl?: string;
  data?: CarouselUserActionData;
  timeoutRedirect?: number;
  confirmActivity?: boolean;
  trackActivity?: boolean;
  closeBtnViewType?: ButtonViewType;
}

export interface CarouselUserActionData extends CfsMenuItemData {
  featureConfig: CarouselUserActionFeatureConfig;
}

export interface CarouselUserActionFeatureConfig {
  canTextInput: boolean;
  canScan: boolean;
  useCustomScanner: boolean;
}

export enum ButtonViewType {
  Primary = "primary",
  Cross = "cross"
}
